/**
 * Organization: Revzoom India Pvt Ltd.
 * User: om
 * Date: 28/03/17
 * Time: 6:33 PM
 */
export class Logger {


  /**
   * @param {string} className Name of class, in which this logger is going to be used.<br>
   *                      Class name will be append in the log messages and will be<br>
   *                      used for filtering.
   */
  constructor(className) {
    this.className = className;
  }

  /**
   * @param {Array}
   * @private
   *
   */
  addClassName(params) {
    params.splice(0, 0, (new Date().toLocaleString()) + " " + '[' + this.className + ']');

  }

  info(...args) {
    if (Level.INFO.canLog(Logger.LEVEL)) {
      if (Logger.FILTER.length === 0 || Logger.FILTER.indexOf(this.className) !== -1) {
        this.addClassName(args);
        args.splice(0, 0, 'INFO: ');
        Logger.logger.info.apply(Logger.logger, args);
      }
    }
  }

  isDebug() {
    return Level.DEBUG.canLog(Logger.LEVEL);
  }

  isLightbox() {
    return Level.LIGHTBOX.canLog(Logger.LEVEL);
  }

  debug(...args) {
    if (Level.DEBUG.canLog(Logger.LEVEL)) {
      if (Logger.FILTER.length === 0 || Logger.FILTER.indexOf(this.className) !== -1) {
        this.addClassName(args);
        args.splice(0, 0, 'DEBUG:');
        Logger.logger.debug.apply(Logger.logger, args);
      }
    }
  }

  warn(...args) {
    if (Level.WARN.canLog(Logger.LEVEL)) {
      if (Logger.FILTER.length === 0 || Logger.FILTER.indexOf(this.className) !== -1) {
        this.addClassName(args);
        args.splice(0, 0, 'WARN: ');
        Logger.logger.warn.apply(Logger.logger, args);
      }
    }
  }

  error(...args) {
    if (Level.ERROR.canLog(Logger.LEVEL)) {
      if (Logger.FILTER.length === 0 || Logger.FILTER.indexOf(this.className) !== -1) {
        this.addClassName(args);
        args.splice(0, 0, 'ERROR: ');
        Logger.logger.error.apply(Logger.logger, args);
      }
    }
  }

}


/**
 * @private
 */
export class Level {

  constructor(priority, name) {
    this.priority = priority;
    this.name = name;
  }

  /**
   *
   * @param level{Level}
   */
  canLog(level) {
    return this.priority >= level.priority;
  }
}
Level.ALL = new Level(0, "ALL");
Level.DEBUG = new Level(30, "DEBUG");
Level.LIGHTBOX = new Level(31, "LIGHTBOX");
Level.INFO = new Level(70, "INFO");
Level.WARN = new Level(80, "WARN");
Level.ERROR = new Level(90, "ERROR");
Level.OFF = new Level(100, "OFF");


class ConsoleLogger {

  constructor() {
  }

  info(...args) {
    console.info.apply(console, args);
  }

  debug(...args) {
    console.debug.apply(console, args);
  }

  warn(...args) {
    console.warn.apply(console, args);
  }

  error(...args) {
    console.error.apply(console, args);
  }

  /**
   *
   * @param {*} obj
   * @private
   */
  getClass(obj) {
    if (typeof obj === "undefined")
      return "undefined";
    if (obj === null)
      return "null";
    if (obj.constructor) {
      return obj.constructor.name;
    }
    return Object.prototype.toString.call(obj)
      .match(/^\[object\s(.*)\]$/)[1];
  }


}

class FileLogger {

}

/**
 * @private
 * @type {ConsoleLogger}
 */
Logger.logger = new ConsoleLogger();
Logger.LEVEL = Level.DEBUG;
/**
 * Add method or class names, which you want to show in logs.<br>
 * Only added names will be show in logs. No filtering will work, if it is left blank.
 * @type {Array}
 */
Logger.FILTER = [];

// /**
//  * @private
//  */
// Logger.SAVED_CONSOLE = console;
// console = new Logger();
// window.console = console;